/**
 * The different coloring systems for charts
 */
const ColorTypes = {
	MANUAL: 'manual',
	SCORE: 'score',
	SPECIFIC: 'specific',
	CONDITIONAL: 'conditional'
}

export { ColorTypes }
const DEFAULT_COLOR_TYPE = ColorTypes.MANUAL
export { DEFAULT_COLOR_TYPE }